import { javantApi } from "../constants";

export const AutoSuggestionService = {
  getData(query) {
    return javantApi.get(`search/suggest?q=${query}`);
  },
};